import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { faPenLine } from '@fortawesome/pro-light-svg-icons/faPenLine';
import { useTranslation } from 'react-i18next';
import { useEventListener } from 'src/core/hooks/useEventListener';
import { Button } from 'src/shared/components/button';
import { Field } from 'src/shared/components/form/field';
import { Icon } from 'src/shared/components/icon';
export function EditableText({ onSave, children, maxLength, isLoading, defaultValue, onEnterEditMode }) {
    const [editMode, setEditMode] = useState(false);
    const [value, setValue] = useState(defaultValue);
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const triggerRef = useRef('unknown');
    function enterEditMode() {
        setEditMode(true);
        setTimeout(() => inputRef.current?.focus());
        onEnterEditMode?.();
    }
    async function handleSave(event) {
        event.preventDefault();
        if (isLoading)
            return;
        const triggerType = triggerRef.current;
        await onSave({ name: value, triggerType });
        setEditMode(false);
        triggerRef.current = 'unknown';
    }
    function handleEnter(event) {
        if (event.key === 'Enter') {
            triggerRef.current = 'enter';
        }
    }
    useEventListener('keydown', function exitEditMode(event) {
        if (document.activeElement === inputRef.current && event.key === 'Escape') {
            setEditMode(false);
            setValue(defaultValue);
        }
    });
    useEffect(function updateValueOnDefaultValueChange() {
        setValue(defaultValue);
    }, [defaultValue]);
    if (editMode) {
        return (_jsxs("form", { onSubmit: handleSave, className: "m-0 flex flex-grow items-center gap-1", children: [_jsx(Field, { className: "flex-grow [--hc-form-field-font-size:var(--hc-size-text-small)] [--hc-form-field-margin-bottom:0]", children: _jsx("input", { value: value, ref: inputRef, maxLength: maxLength, className: "h-[1.75rem]", onKeyDown: handleEnter, onChange: (event) => setValue(event.target.value) }) }), _jsx(Button, { size: "small", type: "submit", variation: "primary", loading: isLoading, disabled: isLoading, onMouseDown: () => (triggerRef.current = 'click'), children: t('general.save') })] }));
    }
    return (_jsxs("div", { className: "group flex items-center gap-2 truncate", children: [children || defaultValue, _jsx(Button, { className: "hidden rounded-medium bg-neutral-200 [--hc-button-neutral-tertiary-focus-border-color:var(--hc-color-neutral-900)] group-hover:block", "aria-label": `${t('general.edit')} ${defaultValue}`, icon: _jsx(Icon, { icon: faPenLine }), size: "small", onClick: enterEditMode, variation: "tertiary", context: "neutral", children: t('general.edit') })] }));
}
